var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7525 32.7704H3.41211L16.7165 11.4375L20.3867 17.4015L10.7525 32.7704Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1288 32.7704L21.0749 18.3191L24.745 24.5125L19.4692 32.7704H12.1288Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0209 32.7704H20.8455L25.4332 25.4301L30.0209 32.7704Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1034 17.4015L25.4332 23.3656L21.763 17.4015L25.4332 11.4375L29.1034 17.4015Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4345 11L29.374 17.4017L25.4345 23.8035L21.495 17.4017L25.4345 11ZM16.7191 11.0021L20.658 17.4028L10.8807 33H3L16.7191 11.0021ZM3.8268 32.5412H10.6268L20.118 17.4006L16.7165 11.8732L3.8268 32.5412ZM22.0337 17.4017L25.4345 22.9281L28.8353 17.4017L25.4345 11.8754L22.0337 17.4017ZM21.0804 17.8765L25.0156 24.5172L19.5961 33H11.7183L21.0804 17.8765ZM12.5419 32.5412H19.3448L24.477 24.5082L21.0719 18.762L12.5419 32.5412ZM25.4345 24.9974L30.4361 33H20.4329L25.4345 24.9974ZM21.2606 32.5412H29.6084L25.4345 25.8631L21.2606 32.5412Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1147 32.7704H47.4551L34.1507 11.4375L30.4805 17.4015L40.1147 32.7704Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7384 32.7704L29.7923 18.3191L26.1221 24.2831L31.398 32.7704H38.7384Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1481 11.002L30.2092 17.4027L39.9865 32.9998H47.8672L34.1481 11.002ZM47.0404 32.5411H40.2404L30.7492 17.4004L34.1507 11.8731L47.0404 32.5411ZM29.7905 17.8824L25.8511 24.2838L31.2692 32.9998H39.1489L29.7905 17.8824ZM38.3253 32.5411H31.5242L26.3906 24.2825L29.7916 18.7558L38.3253 32.5411Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarlock);
export default __webpack_public_path__ + "static/media/warlock.68d740f39e228b71cf7448190a058a9a.svg";
export { ForwardRef as ReactComponent };